// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-T8ZU","header":"styles_header__YTKBo","testimonialPersonInfo":"styles_testimonialPersonInfo__dSUax","text":"styles_text__MjUus"};